import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import { MessageBox } from 'element-ui';
export function deteleObject(arr) {
  var result = [];
  var obj = {};
  var msg = [];
  for (var i = 0; i < arr.length; i++) {
    if (!obj[arr[i].id]) {
      result.push(arr[i]);
      obj[arr[i].id] = true;
    } else {
      msg.push(arr[i].realname || arr[i].email || arr[i].mobile);
      console.log(msg);
    }
  }
  if (msg.length > 0) {
    MessageBox.alert(msg.join() + '已存在已选人员列表, 该次操作不会添加他们', '提示');
  }
  console.log(result);
  return result;
}